/* ------------------------ Login ------------------------ */
/* Main Screen */
export const slugEmail = "E-mail do Admin";
export const slugPassword = "Senha do Admin";
export const placeholderEmail = "nome@email.com.br";
export const placeholderPassword = "Insira sua senha";
export const btnTextLogin = "Entrar como Admin";
